import {PortalServices} from "./portal-services";


export class SmapPortalServices extends PortalServices {
    baseUri(): string {
        return '/portal-services';
    }
}
